import { readonly } from 'svelte/store';
import { pageState } from './page.js';
export { setComponetsMap, getComponent } from './resolvers.js';
export { sharedWritable, clientWritable } from './store.js';
export const page = readonly(pageState);
export function toRoute(path) {
    if (import.meta.env.SSR)
        throw new Error('No puedes llamar toRoute en el servidor');
    history.pushState(null, '', path);
    window.dispatchEvent(new Event('popstate'));
}
export { default as Render } from './Renderer.svelte';
